<template>
  <!-- prettier-ignore -->
  <div class="ovp-benefits-widget-wrapper">
    <ovp-benefits-table
      v-if="benefitsTableData"
      class="ovp-benefits-widget"
      :benefits-data="benefitsTableData"
      :app-version="$version"
      :app-name="$options.name"
      :app-language="$i18n.locale"
      :selected-id="selectedId"
      is-www
    />
  </div>
</template>

<script>
import Vue from '@/setup'

import OvpBenefitsTable from '@/components/Benefits/BenefitsTable'

import { BenefitsHelper } from '@/helpers'

const parse = location => import('url-parse').then(parser => parser.default(location.href, true))

export default Vue.extend({
  name: 'BenefitsWidget',

  components: {
    OvpBenefitsTable,
  },

  props: {
    benefitColumns: {
      type: String,
      required: true,
    },

    benefitPath: {
      type: String,
      required: true,
    },

    benefitSelectedId: {
      type: String,
      default: null,
    },

    benefitShowProductLinks: {
      type: String,
      default: 'false',
    },
  },

  data() {
    return {
      benefits: null,
      benefitsTableData: null,
      columns: this.benefitColumns.split(','),
      path: this.benefitPath,
      selectedId: this.benefitSelectedId,
    }
  },

  created() {
    this.$notification.setTranslator((key, params) => this.$t(key, params))
  },

  mounted() {
    if (window.location?.search.indexOf('selectedId')) {
      this.initalLocationParams()
    }

    this.loadContent()
  },

  methods: {
    async initalLocationParams() {
      const location = await parse(window.location)
      const columnsQuery = location.query?.columns
      const selectedIdQuery = location.query?.selectedId
      const pathQuery = location.query?.path

      const hasAllParams = columnsQuery && selectedIdQuery && pathQuery

      if (Object.keys(location?.query).length > 0 && hasAllParams) {
        this.columns = columnsQuery?.split(',')
        this.selectedId = selectedIdQuery

        const tmp = this.benefitPath.split('/')
        tmp[tmp.length - 1] = pathQuery
        this.path = tmp.join('/')
      }
    },

    loadContent() {
      this.$backend.resources.getContentByPath(this.path).then(response => {
        this.benefits = response.data || response
        this.benefitsTableData = BenefitsHelper.getBenefitsTableData(
          response,
          this.columns,
          this.selectedId,
          this.benefitShowProductLinks === 'true'
        )
      })
    },
  },
})
</script>

<style name="mobile" scoped>
.ovp-benefits-widget {
  margin-bottom: 10px;

  &-wrapper {
    min-height: 100px;
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .ovp-benefits-widget {
    margin-bottom: 0;
  }
}
</style>
